const VAPID_PUBLIC_KEY = 'BEM13HS7L-VhVnyRS9-wSZQNnL962sj8vsSVZNeLKa5zDV2mZaWzk43HAbFLfGk22ULyjr6pahm2Ig1auDt-GqQ';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export async function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return null;
  const registration = await navigator.serviceWorker.register('/sw.js');
  return registration;
}

export async function subscribeUserToPush(userId, db) {
  try {
    const registration = await registerServiceWorker();
    if (!registration) return { success: false, error: 'Service worker not supported' };

    const permission = await Notification.requestPermission();
    if (permission !== 'granted') return { success: false, error: 'Permission denied' };

    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
    });

    const { doc, setDoc } = await import('firebase/firestore');
    await setDoc(doc(db, 'pushSubscriptions', userId), {
      userId,
      subscription: JSON.stringify(subscription),
      createdAt: new Date(),
    });

    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
}

export async function unsubscribeUserFromPush(userId, db) {
  try {
    const registration = await navigator.serviceWorker.getRegistration('/sw.js');
    if (registration) {
      const subscription = await registration.pushManager.getSubscription();
      if (subscription) await subscription.unsubscribe();
    }
    const { doc, deleteDoc } = await import('firebase/firestore');
    await deleteDoc(doc(db, 'pushSubscriptions', userId));
    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
}

export function isPushSupported() {
  return 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
}